export default __webpack_public_path__ + "static/media/img9.06ba75b7.jpeg";